import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  hiddenRow: {
    display: 'none',
  },
  table: {
    border: '1px solid rgba(109,114,120,0.18)',
    borderRadius: 4,
    '& tbody': {
      '& tr:nth-child(even)': {
        backgroundColor: '#f9f9f9',
      },
      '& tr': {
        '& td': {
          padding: '0 4px',
          height: '52px',
        },
      },
    },
  },
  exceptionRow: {
    background: '#fff0b8',
  },
  label: {
    fontSize: '13px',
    color: '#455a64',
    marginBottom: 6,
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, -2px) scale(1)',
      },
    },
  },
}));